module.exports = __webpack_public_path__ + "assets/stepnone.3bd65407.svg";